import { render } from "./CommitModal.vue?vue&type=template&id=3b2c2710&scoped=true"
import script from "./CommitModal.vue?vue&type=script&lang=js"
export * from "./CommitModal.vue?vue&type=script&lang=js"

import "./CommitModal.vue?vue&type=style&index=0&id=3b2c2710&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2c2710"]])

export default __exports__